import React from 'react'
import { PrismicRichText } from '@prismicio/react'

// Components
import Card from './card'

const CardDeck = ({ slice }) => {
  var numberOfCards = slice.items.length

  return (
    <section className={`component-${slice.slice_type} max-w-screen-xl mx-auto py-5 sm:py-8 px-4 lg:px-0`}>
      <ul className={` grid grid-cols-1 gap-4 ${numberOfCards > '' ? 'md:grid-cols-3 xl:grid-cols-4' : 'md:grid-cols-2 xl:grid-cols-3'}`}>
        {slice.primary.title.html && (
          <li className='flex items-center flex-1 justify-center xl:justify-end xl:text-right sm:mx-4 title md:col-span-3 xl:col-span-1'>
            <PrismicRichText field={slice.primary.title.richText} />
          </li>
        )}
        {slice.items.map((card, index) => {
          return <Card fields={card} key={`card-${index}`} />
        })}
      </ul>
    </section>
  )
}

export default CardDeck
